import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {CheckoutsSelectors} from '@store/checkouts/checkouts.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {CoverImageComponent} from '@aviary/components/cover-image/cover-image.component';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {MatTooltip} from '@angular/material/tooltip';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';

@Component({
  selector: 'px-recent-borrowing-history',
  templateUrl: './recent-borrowing-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCard, SelectPipe, MatCardContent, CoverImageComponent, NamedRouterLinkDirective, HiddenUntilLoadedDirective, MatTooltip, LinkButtonComponent,
    ButtonRouteNameDirective
  ]
})
export class RecentBorrowingHistoryComponent {
  public readonly selectors = CheckoutsSelectors.BorrowingHistory;
  public readonly patronSelectors = PatronSelectors.Auth;
}
